import {confirmPlus} from 'admin/common/custom_confirm'
import {DNICampaigns} from './dni_campaigns'
import {DNITriggers} from './dni_triggers'
import {URLRedirects} from './url_redirects'
import {DNIAdvancedSettings} from './dni_campaigns_create'
import {CampaignTags} from '../campaigns/campaign_tags'

export class DNICampaignsEdit extends HTMLElement {
  constructor(domain_id, campaign_id, list_view, rows_data, is_admin) {
    super();
    this._is_admin = is_admin
    this.domain_id = domain_id
    this.campaign_id = campaign_id
    this.list_view = list_view;
    this.rows_data = rows_data;
  }
  async connectedCallback() {
    pageLoadingFrame("show")
    let res = await fetch(`/admin/domains/${this.domain_id}/dni_campaigns/${this.campaign_id}`);
    let json = await res.json();
    this.all_numbers = this.rows_data.map(obj => obj.static_number).toArray();
    pageLoadingFrame("hide")

    this.target_type = json.target.target_type
    let consumer_greeting = this.target_type == 'DEFAULT' ?  this.getAudioIdForActionTiming(json, 1) : null;
    let sales_rep_whisper = this.target_type == 'DEFAULT' ? this.getAudioIdForActionTiming(json, 3) : null;
    let webhooks = this.target_type == 'DEFAULT' ? json.target.children[0].target_child_actions.filter(obj => obj.action.action_type == 'WEBHOOK' || obj.action.action_type == 'EMAIL') : null;
    let representive_code = this.target_type == 'DEFAULT' && json.target.children[0].target_child_actions.filter(obj => obj.action.action_type == 'REP_CODE').length > 0 ? 1 : 0;
    let voicemail_enabled = this.target_type == 'DEFAULT' && json.target.children[0].destination.children && json.target.children[0].destination.children.filter(obj => obj.description == 'Voicemail Target').length > 0 ? 1 : 0;
    let voicemail_greeting = this.target_type == 'DEFAULT' && voicemail_enabled && json.target.children[0].destination.children[0].destination.target_audio ? json.target.children[0].destination.children[0].destination.target_audio.target_audio_id : null;
    let voicemail_rollover_time = this.target_type == 'DEFAULT' && voicemail_enabled ? json.target.children[0].destination.children[0].failure_timeout : 0;

    this._data = json;
    console.log(this._data)
    this.innerHTML = 
    `<style>
      .fas {
        font-family: FontAwesome;
      }
      .edit-dni-pool-input {
        width: 75px;
        display: inline-block;
        font-size: 16px;
        margin-right: 10px;
      }
      .edit-dni-pool-size {
        font-size: 16px;
        font-weight: 600;
      }
      .edit-dni-left input, .edit-dni-left select, .edit-dni-left .selectize-input {
        margin-bottom: 20px;
      }
      .edit-dni-right {
        margin-top: -19px;
      }
      .edit-dni-status {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
      }
      #edit-active, #edit-paused {
        cursor: pointer;
      }
      #edit-active.active {
        color: green;
        font-weight: bold;
      }
      #edit-paused.active {
        color: red;
        font-weight: bold;
      }
      .edit-dni-switches {
        padding: 10px;
      }
      .edit-dni-add-options label {
        display: block;
      }
      .edit-dni-add-options div {
        min-height: 30px
      }
      dni-campaigns-edit .campaign_webhooks_container {
        margin-left: -10px;
      }
      dni-campaigns-edit .campaign_webhooks_container label {
        margin-left: 10px;
      }
      .call-options .form-horizontal {
        display: flex;
        justify-content: space-between;
      }
      #dni-pool-size {
        text-align: center;
        color: #6B6B6B;
      }
      dni-campaigns-edit .selectize-control.multi .selectize-input>div {
        color: #FFF;
      }
      #edit-dni-address-checkbox {
        margin-left: 10px;
      }
      #edit-dni-ct-radio label {
        margin: 20px 60px 20px 0;
      }
      .call-options > div {
        min-height: 180px !important;
      }
      dni-campaigns-edit .panel {
        float: none;
      }
      .col-md-8 i {
        font-style: italic;
        font-weight: normal;
      }

    </style>
    <div class="row" id="edit-dni-main">
      <div class="col-lg-9 col-md-12">
        <h3><span id="campaign-back"></span> Edit Digital Campaign</h3>
      </div>
      <div class="col-sm-12 col-md-6 edit-dni-left">
        <div class="errors"></div>
        <div class="col-sm-12">
          <label>Name</label>
          <input type="text" class="form-control" id="edit-dni-name" data-cy="edit-dni-name" value="${this._data.campaign_name}" maxlength="40">
        </div>
        <div class="col-sm-12">
        
          <div class="tags-container"></div>
          <label>Phone Number to Replace</label>
          <input type="text" is="ring-to-endpoint" class="form-control ring_to_endpoint" id="edit-dni-number" data-cy="edit-dni-number" data-key="ring_to_endpoint" value="${this._data.static_number}" placeholder="(123) 444-5566">
          <div class="edit-dni-pool">
            <span class="edit-dni-pool-size">Pool Size </span>
            <input type="text" class="form-control edit-dni-pool-input" id="dni-pool-size" readonly="readonly" value="${this._data.dni_campaign_pool.length}">
          </div>
        </div>
        <input id="edit-dni-address-checkbox" type="checkbox" ${this._data.location_name || this._data.location_address_line_1 || this._data.location_address_line_2 || this._data.location_address_city || this._data.location_address_state || this._data.location_address_zip ? '' : 'checked'}><span> Use Default Address</span>
        <div class="dni-address row  ${this._data.location_name || this._data.location_address_line_1 || this._data.location_address_line_2 || this._data.location_address_city || this._data.location_address_state || this._data.location_address_zip ? '' : 'hidden'}">
          <label>Location Name</label>
          <input id="edit-dni-location-name" class="form-control" type="text" placeholder="Location Name" value="${this._data.location_name ? this._data.location_name : ''}">
          <label>Address Line 1</label>
          <input id="edit-dni-address-1" class="form-control" type="text" placeholder="Address Line 1" value="${this._data.location_address_line_1 ? this._data.location_address_line_1 : ''}">
          <label>Address Line 2</label>
          <input id="edit-dni-address-2" class="form-control" type="text" placeholder="Address Line 2" value="${this._data.location_address_line_2 ? this._data.location_address_line_2 : ''}">
          <label>City</label>
          <input id="edit-dni-city" class="form-control" type="text" placeholder="City" value="${this._data.location_address_city ? this._data.location_address_city : ''}">     
          <div class="col-sm-6" style="padding-left: 0;">
            <label>State/Province/Region</label>
            <input id="edit-dni-region" class="form-control" type="text" placeholder="State/Province/Region"  value="${this._data.location_address_state ? this._data.location_address_state : ''}">
          </div>
          <div class="col-sm-6" style="padding-right: 0;">
            <label>Zip/Postal Code</label>
            <input id="edit-dni-zip" class="form-control" type="text" placeholder="Zip/Postal Code"  value="${this._data.location_address_zip ? this._data.location_address_zip : ''}">
          </div>
        </div>
        <div class="form-group-separated">
          <div class="errors" data-cy="errors-3"></div>
          <div class="col-sm-12" id="edit-dni-ct-radio">
            <input type="radio" name="step-3-toggle" id="ring-to-radio" data-cy="ring-to-radio" ${this.target_type == 'DEFAULT' ? 'checked' : ''}>
            <label>Ring to Number
            <span class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" data-html="true" 
            title="<p style='text-align:left'>Forward call to the phone number or SIP address of your choice</p>"</span>
            </span>
            </label>
            <input type="radio" name="step-3-toggle" id="call-treat-radio" data-cy="call-treat-radio" ${this.target_type == 'TREATMENT' ? 'checked' : ''}>
            <label>Call Treatment</label>
          </div>
          <div class="${this.target_type == 'TREATMENT' ? 'hidden' : ''}" id="ring-to-panel" data-cy="ring-to-panel">
            <input type="text" is="ring-to-endpoint" class="form-control ring_to_endpoint" id="new-dni-rtn" data-cy="new-dni-rtn" data-key="ring_to_endpoint" value="${this.target_type == 'DEFAULT' ? this._data.target.children[0].destination.ring_to_endpoint : ''}" placeholder="(123) 444-5566 or SIP Target">
            <div id="step-3-audio" class="col-sm-12 no-gutters">
              <div><label>Consumer Greeting</label></div>
              <div class="col-sm-12 no-gutters audio-select-row">
                <select is=audio-select target_audio_type=2 class="form-control" id="consumer-greeting-select" data-cy="consumer-greeting" data-selected="${this.target_type == 'DEFAULT' ? consumer_greeting : null}"></select>
                <button class="btn btn-secondary ct_manage_audio" data-audio-type-id="2">Manage</button>
              </div>
              <div><label>Sales Rep Whisper</label></div>
              <div class="col-sm-12 no-gutters audio-select-row">
                <select is=audio-select target_audio_type=4 class="form-control" id="sales-rep-select" data-cy="sales-rep-whisper" data-selected="${this.target_type == 'DEFAULT' ? sales_rep_whisper : null}"></select>
                <button class="btn btn-secondary ct_manage_audio" data-audio-type-id="4">Manage</button>
              </div>
            </div>

          <div class="form-horizontal col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 no-gutters" align="right" role="form" style="margin-bottom: 12px">
            <label class="col-md-5 no-gutters" align="left">Call Ends - Assign Representative Code</label>
            <div class="col-md-7"  align="left">
              <label class="switch">
                <input type="checkbox" class="form-control switch" id="representive-code-switch" ${this.target_type == 'DEFAULT' && representive_code == 1 ? "checked" : ""}>
                <span data-cy="representive-code-switch"></span>
              </label>
            </div>
          </div>

          <div class="form-horizontal col-sm-12 no-gutters" align="right" role="form">
              <label class="col-md-5 no-gutters" align="left">Voicemail</label>
              <div class="col-md-2"  align="left">
                <label class="switch">
                  <input type="checkbox" class="form-control switch" id="dni-voicemail-switch" ${this.target_type == 'DEFAULT' && voicemail_enabled == 1 ? "checked" : ""}>
                  <span data-cy="dni-voicemail-switch"></span>
                </label>
              </div>
              <div id="dni_voicemail_rings_container" class="col-md-5 ${this.target_type == 'DEFAULT' && voicemail_enabled == 1 ? "" : "hidden"}" align="left">
                <label class="col-md-4">Number of Rings</label>
                <div class="col-md-4 no-gutters">
                  <select id="dni_voicemail_rings" class="form-control">
                    <option value="0">0</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                  </select>
                </div>
              </div>
            </div>
            <div id="dni_voicemail_audio" class="col-sm-12 no-gutters ${this.target_type == 'DEFAULT' && voicemail_enabled == 1 ? "" : "hidden"}">
              <div class="col-sm-12 no-gutters"><label>Voicemail Greeting</label></div>
              <div class="col-sm-12 no-gutters audio-select-row">
                <select is=audio-select target_audio_type=6 class="form-control" id="dni-voicemail-greeting-select" data-cy="dni-voicemail-greeting-select" default_option_text="Default" data-selected="${this.target_type == 'DEFAULT' ? voicemail_greeting : null}"></select>
                <button class="btn btn-secondary ct_manage_audio" data-audio-type-id="6">Manage</button>
              </div>
            </div>

            <div class="campaign_webhooks_container" data-cy="campaign-webhooks">
              <label class="control-label">Webhook</label>
              ${webhooks != null && webhooks.length > 0 ? webhooks.map(webhook => `<webhook-form data-action-id=${webhook.action_id} data-action-timing=${webhook.action_timing}></webhook-form>`).join("") : "<webhook-form></webhook-form>"}
            </div>
          </div>
          <div class="col-sm-12 ${this.target_type == 'DEFAULT' ? 'hidden' : ''}" id="call-treat-panel" data-cy="call-treat-panel">
            <label>Call Treatment</label>
            <select is=treatments-select class="form-control call_treatments_id" data-cy="call-treat-id" data-selected="${this.target_type == 'TREATMENT' ? this._data.target.target_id : null}"></select>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-6 row edit-dni-right">
        <div class="row">
          <div class="col-sm-12 edit-dni-status">
            <span style="padding-top:8px;">${this._data.status == DNICampaigns.STATUS.ARCHIVED ? "" : `<b>Status: <span id='edit-active' class='dni-status ${this._data.status == DNICampaigns.STATUS.ACTIVE ? "active" : ""}' data-cy="edit-active">Active</span> | 
                <span id='edit-paused' class='dni-status ${this._data.status != 1 ? "active" : ""}' data-cy="edit-paused">Pause</span></b>`}
            </span>
            <span><b style="padding-top:5px;">Changes:</b>&nbsp <audit-log href="/admin/domains/${this.domain_id}/dni_campaigns/${this.campaign_id}/audits"></audit-log></span>
            <!--span>7 Day Call Count:</span-->
            ${this._is_admin ?
              `
              <button class="btn btn-outline-danger" id="dni-delete">Delete</button>
              `: ``}
          </div>
        </div>
        <div class="col-sm-12 panel panel-default edit-dni-switches">
          <div class="row call-options">
            <div class="col-sm-12 col-md-6">
              <div class="form-group form-horizontal col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" align="right" role="form">
                <label class="col-md-6" align="left">CallShield</label>
                <div class="col-md-6"  align="right">
                  <label class="switch">
                    <input type="checkbox" class="form-control switch" id="call-shield-switch" ${this._data.call_shield ? 'checked' : ''}>
                    <span data-cy="call-shield-switch"></span>
                  </label>
                </div>
              </div>
              ${this._is_admin ?
              `<div class="form-group form-horizontal col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" align="right" role="form">
                <label class="col-md-6" align="left">LeadScore</label>
                <div class="col-md-6"  align="right">
                  <label class="switch">
                    <input type="checkbox" class="form-control switch" id="call-processing-map-switch" ${this._data.call_processing_map ? 'checked' : ''}>
                    <span data-cy="call-processing-map-switch"></span>
                  </label>
                </div>
              </div>` : ''}
              <div class="form-group form-horizontal col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" align="right" role="form">
                <label class="col-md-6" align="left">Call Recording 
                <span>
                <span class="fas fa-question-circle" data-toggle="tooltip" data-placement="right" data-html="true" 
                title="<p style='text-align:left'>Call Recording includes a Recording Disclaimer to announce this call is being recorded</p>"</span>
                </span>
                </label>
                <div class="col-md-6"  align="right">
                  <label class="switch">
                    <input type="checkbox" class="form-control switch" id="call-rec-switch" ${this._data.call_recording ? 'checked' : ''}>
                    <span data-cy="call-rec-switch"></span>
                  </label>
                </div>
              </div>

              ${this._is_admin ? `
              <div class="dni-speech-transcription-enabled ${!this._data.call_recording ? 'hidden' : ''}" id="redaction-panel">
                <div class="form-group form-horizontal col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" align="right" role="form">
                  <label class="col-md-6" align="left">Speech Transcription
                  </label>
                  <div class="col-md-6"  align="right">
                    <label class="switch">
                      <input type="checkbox" class="form-control switch" id="speech-transcription-enabled-switch" ${this._data.speech_transcription ? 'checked' : ''}>
                      <span data-cy="speech-transcription-enabled-switch"></span>
                    </label>
                  </div>
                </div>
                <div class="form-group form-horizontal col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" align="right" role="form">

                  <label class="col-md-6" align="left">Redaction
                  </label>
                  <div class="col-md-6"  align="right">
                    <label class="switch">
                      <input type="checkbox" class="form-control switch" 
                      ${this._data.speech_transcription ? '' : 'disabled'}
                      id="redaction-enabled-switch" ${this._data.redaction ? 'checked' : ''}>
                      <span data-cy="redaction-enabled-switch"></span>
                    </label>
                  </div>

                </div>
              </div>
              ` : ``} 

            </div>
            <div class="col-sm-12 col-md-6">
              ${this.isTollFree() ? '' : `<div class="form-group form-horizontal col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" align="right" role="form">
                <label class="col-md-8 no-gutters" align="left">Texting Enabled <br>    
                </label>
                <div class="col-md-4"  align="right">
                  <label class="switch">
                    <input type="checkbox" class="form-control switch" id="texting-enabled-switch" ${this._data.text_enabled ? 'checked' : ''} ${this._data.has_pending_text_enabled ? "disabled" : ""}>
                    <span data-cy="texting-enabled-switch"></span>
                  </label>
                </div>
              </div>
              <div class="row col-sm-12 dni-text-enabled ${this._data.text_enabled ? '' : 'hidden'}" id="texting-enabled-panel">
                <div class="col-sm-2 no-gutters">
                  <label>Team</label>
                </div>
                <div class="col-sm-10">
                  <select name="teams" is="teams-select" class="select-teams form-control" id="texting-team-select" data-selected="${this._data.texting_team_id}"></select>
                </div>
              </div>`}
              <div class="${this._data.call_recording ? '' : 'hidden'}" id="disclaimer-panel" data-cy="call-disclaimer">
                <div>
                  <label>Recording Disclaimer</label>&nbsp<span>(Please select language):</span>
                </div>
                <div>
                  <input type="radio" name="disclaimer-lang" value="1" data-cy="lang-english" ${this._data.call_disclaimer == 1 ? 'checked' : ''}>
                  <label>English</label>
                </div>
                <div>
                  <input type="radio" name="disclaimer-lang" value="2" data-cy="lang-spanish" ${this._data.call_disclaimer == 2 ? 'checked' : ''}>
                  <label>Spanish</label>
                </div>
                <div>
                  <input type="radio" name="disclaimer-lang" value="3" data-cy="lang-french"  ${this._data.call_disclaimer == 3 ? 'checked' : ''}>
                  <label>French</label>
                </div>
                ${this._is_admin || (this._data.call_recording && this._data.call_disclaimer == 0) ? `<div><input type="radio" name="disclaimer-lang" value="0" data-cy="lang-none"  ${this._data.call_disclaimer == 0 ? 'checked' : ''}> <label>None</label></div>` : ''}
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 edit-dni-add-options">
          
        </div>
      </div>
      <div class="col-sm-12">                                                                        
        <button class="btn btn-primary pull-right campaign-row-button" id="save-edit-dni-campaign" data-cy="save-edit-dni-campaign">Save</button>
        <button class="btn btn-outline-secondary pull-right campaign-row-button step-cancel">Cancel</button>
      </div>
    </div>
    `;

    this.querySelector(".tags-container").appendChild(new CampaignTags(this.domain_id, json.tags));

    let dni_manage_pools = new DNIManagePools(this._data.dni_campaign_pool, this.domain_id, this.campaign_id, this.poolSize.bind(this));
    this.querySelector('.edit-dni-pool').appendChild(dni_manage_pools);
    let dni_triggers = new DNITriggers(this._data.dni_campaign_parameter_triggers);
    this.querySelector('.edit-dni-add-options').appendChild(dni_triggers);
    let url_redirects = new URLRedirects(this._data.dni_campaign_parameter_targets, this.dni_campaign_parameter_redirect);
    this.querySelector('.edit-dni-add-options').appendChild(url_redirects);

    this.querySelectorAll(".dni-status").forEach((elem) => elem.addEventListener("click", async (e) => {
      e.preventDefault();
      if(e.target.classList.contains('active')) {
        return;
      }

      if(e.target.id == "edit-paused") {
        if(await confirmPlus(`Are you sure you want to Pause?<br>The Campaign Pause is for 30 days.`)) {
          if(await this.setStatus(DNICampaigns.STATUS.PAUSED)) {
            this.querySelector("#edit-active").classList.remove("active");
            e.target.classList.add("active");
            this._data.status = DNICampaigns.STATUS.PAUSED;
            this.list_view.updateCampaignData(this._data)
            Common.notify('Campaign paused.', 'success');
          }
        }
      } else {
        if(await this.setStatus(DNICampaigns.STATUS.ACTIVE)) {
          this.querySelector("#edit-paused").classList.remove("active");
          e.target.classList.add("active");
          this._data.status = DNICampaigns.STATUS.ACTIVE;
          this.list_view.updateCampaignData(this._data)
          Common.notify('Campaign activated.', 'success');
        }
      }     
    }));

    if(this._is_admin) {
      this.querySelector("#dni-delete").addEventListener("click", async(e) => {
        e.preventDefault();
        if(await confirmPlus(`Are you sure you want to Delete this Campaign?`)) {
            if(await this.setStatus(DNICampaigns.STATUS.ARCHIVED)) {
              this.list_view.show();
              this.list_view.removeCampaign(this._data)
              this.remove();
              Common.notify('Campaign deleted.', 'success');
            }
          }
      });
    }

    this.querySelector('#campaign-back').addEventListener('click', this.cancelEdit.bind(this));

    this.querySelector('#edit-dni-address-checkbox').addEventListener('click', function() {
      this.querySelector('#edit-dni-address-checkbox').checked == true ? this.querySelector('.dni-address').classList.add('hidden') : this.querySelector('.dni-address').classList.remove('hidden')
    }.bind(this))

    this.querySelector(".step-cancel").addEventListener("click", this.cancelEdit.bind(this));

    this.querySelector('#call-rec-switch').addEventListener('click', function() {
      if(this.querySelector('#call-rec-switch').checked == false) {
        this.querySelector('#disclaimer-panel').classList.add('hidden');
        if(this._is_admin) {
          this.querySelector('.dni-speech-transcription-enabled').classList.add('hidden');
        }
      } else {
        this.querySelector('#disclaimer-panel').classList.remove('hidden');
        if(this._is_admin) {
          this.querySelector('.dni-speech-transcription-enabled').classList.remove('hidden');
        }
      }
    }.bind(this))

    if(this._is_admin) {
      this.querySelector('#speech-transcription-enabled-switch').addEventListener('click', function() {
        if(this.querySelector('#speech-transcription-enabled-switch').checked == false) {
          this.querySelector('#redaction-enabled-switch').setAttribute('disabled', true);
        } else {
          this.querySelector('#redaction-enabled-switch').removeAttribute('disabled');
        }
      }.bind(this))
    }

    if(!this.isTollFree()) {
      this.querySelector('#texting-enabled-switch').onchange = (e) => {
        if(e.target.checked) {
          this.querySelector('#texting-enabled-panel').classList.remove('hidden');
        } else {
          this.querySelector('#texting-enabled-panel').classList.add('hidden');
        }
      }
    }

    this.querySelectorAll('#edit-dni-ct-radio input').forEach(radio => {
      radio.addEventListener('click', function() {
        let ringToPanel = this.querySelector('#ring-to-panel');
        let callTreatPanel = this.querySelector('#call-treat-panel');
        if(this.querySelector('#ring-to-radio').checked){
          ringToPanel.classList.remove('hidden');
          callTreatPanel.classList.add('hidden');
          this.querySelector('.call_treatments_id').value = "";
        } else if(this.querySelector('#call-treat-radio').checked) {
          ringToPanel.classList.add('hidden');
          callTreatPanel.classList.remove('hidden');
        }
      }.bind(this))
    })

    this.querySelector("#save-edit-dni-campaign").addEventListener('click', function(e) {
      e.preventDefault();
      this.save(e)
    }.bind(this))

    $(this.querySelector(".select-tags")).selectize({
      maxItems: 10,
      plugins: ['remove_button']
    });
    
    this.querySelector('#dni-voicemail-switch').addEventListener('click', function() {
      if(this.querySelector('#dni-voicemail-switch').checked == false) {
        this.querySelector('#dni_voicemail_rings_container').classList.add('hidden');
        this.querySelector('#dni_voicemail_audio').classList.add('hidden');
      } else {
        this.querySelector('#dni_voicemail_rings_container').classList.remove('hidden');
        this.querySelector('#dni_voicemail_audio').classList.remove('hidden');
      }
    }.bind(this))

    this.querySelector('#dni_voicemail_rings').value = voicemail_rollover_time;
  }

  getAudioIdForActionTiming(json, action_timing) {
    let actions_for_timing = json.target.children[0].target_child_actions.filter(obj => obj.action.action_type == 'AUDIO' && obj.action_timing == action_timing)
    return actions_for_timing.length > 0 ? actions_for_timing[0].action.action_parameters.filter(obj => obj.parameter_name == 'audio_id')[0].parameter_value : null;
  }

  getAudioIdForVoicemail(json, action_timing) {
    let actions_for_timing = json.target.children[0].destination.children.filter(obj => obj.action.action_type == 'AUDIO' && obj.action_timing == action_timing)
    return actions_for_timing.length > 0 ? actions_for_timing[0].action.action_parameters.filter(obj => obj.parameter_name == 'audio_id')[0].parameter_value : null;
  }

  async save(e) {
    if(this.validate() && this.querySelector('dni-triggers').validate() && this.querySelector('url-redirects').validate()) {
      e.preventDefault();
      let button = e.target;
      button.disabled = true;
      let updated_dni_campaign = JSON.parse(JSON.stringify(this._data))
      updated_dni_campaign.campaign_name = this.querySelector('#edit-dni-name').value;
      updated_dni_campaign.static_number = this.querySelector('#edit-dni-number').value.replace(/\D/g,'');

      updated_dni_campaign.campaign_tag_data = this.querySelector("campaign-tags").getData();

      if(!this.querySelector("#edit-dni-address-checkbox").checked) {
        updated_dni_campaign.location_name = this.querySelector("#edit-dni-location-name").value;
        updated_dni_campaign.location_address_line_1 = this.querySelector("#edit-dni-address-1").value;
        updated_dni_campaign.location_address_line_2 = this.querySelector("#edit-dni-address-2").value;
        updated_dni_campaign.location_address_city = this.querySelector("#edit-dni-city").value;
        updated_dni_campaign.location_address_state = this.querySelector("#edit-dni-region").value;
        updated_dni_campaign.location_address_zip = this.querySelector("#edit-dni-zip").value;
      } else {
        updated_dni_campaign.location_name = null;
        updated_dni_campaign.location_address_line_1 = null;
        updated_dni_campaign.location_address_line_2 = null;
        updated_dni_campaign.location_address_city = null;
        updated_dni_campaign.location_address_state = null;
        updated_dni_campaign.location_address_zip = null;
      }

      updated_dni_campaign.call_shield = this.querySelector('#call-shield-switch').checked ? 1 : 0;

      if(this.querySelector('#call-processing-map-switch')) {
        updated_dni_campaign.call_processing_map = this.querySelector('#call-processing-map-switch').checked ? 1 : 0;
      }
      
      updated_dni_campaign.call_recording = this.querySelector('#call-rec-switch').checked ? 1 : 0;
      updated_dni_campaign.call_disclaimer = updated_dni_campaign.call_recording ? this.querySelector('input[name="disclaimer-lang"]:checked').value : 0;

      if(!this.isTollFree()) {
        updated_dni_campaign.text_enabled = this.querySelector('#texting-enabled-switch').checked ? 1 : 0;
        updated_dni_campaign.texting_team_id = this.querySelector('#texting-team-select').value;
      }

      if(this._is_admin) {
        updated_dni_campaign.speech_transcription = updated_dni_campaign.call_recording && this.querySelector('#speech-transcription-enabled-switch').checked ? 1 : 0;
        if (updated_dni_campaign.speech_transcription) {
          updated_dni_campaign.redaction = this.querySelector('#redaction-enabled-switch').checked ? 1 : 0;
        } else {
          // if transcription is off, force redaction to be off too.
          updated_dni_campaign.redaction = 0;
        }
      }
      

      if(this.querySelector('#ring-to-radio').checked == true) {
        if(updated_dni_campaign.target.target_type != "") {
          updated_dni_campaign.target = {};
          let ring_to = this.querySelector('#new-dni-rtn').value.split("@");
          if(ring_to.length == 1) {
            updated_dni_campaign.target.ring_to_number = ring_to[0].replace(/\D/g,'');
            updated_dni_campaign.target.ring_to_domain = null;
          } else {
            updated_dni_campaign.target.ring_to_number = ring_to[0].replace(/\D/g,'');
            updated_dni_campaign.target.ring_to_domain = ring_to[1]
          }

          updated_dni_campaign.target.actions = [];

          let consumer_greeting = this.querySelector('#consumer-greeting-select').value;
          if(consumer_greeting != "null") {
            let action = {
              action_timing: 1,
              action_type: "AUDIO",
              action_parameters: [{
                parameter_name: "audio_id",
                parameter_value: consumer_greeting
              }, 
              {
                parameter_name: "channel",
                parameter_value: DNIAdvancedSettings.CHANNEL_AUDIO_CONSUMER
              }]
            }
            updated_dni_campaign.target.actions.push(action);
          }
          
          let sales_rep_whisper = this.querySelector('#sales-rep-select').value;
          if(sales_rep_whisper != "null") {
            let action = {
              action_timing: 3,
              action_type: "AUDIO",
              action_parameters: [{
                parameter_name: "audio_id",
                parameter_value: sales_rep_whisper
              }, 
              {
                parameter_name: "channel",
                parameter_value: DNIAdvancedSettings.CHANNEL_AUDIO_TARGET
              }]
            }
            updated_dni_campaign.target.actions.push(action);
          }
          
          this.querySelectorAll("webhook-form").forEach((webhook_form) => {
            let webhook_value = webhook_form.getValue();
            if(webhook_value != null) {
              updated_dni_campaign.target.actions.push(webhook_value);  
            }
          });

          if(this.querySelector("#representive-code-switch").checked) {
            updated_dni_campaign.target.actions.push({
              action_timing: 6,
              action_type: "REP_CODE"
            })
          }

          updated_dni_campaign.voicemail_enabled = this.querySelector("#dni-voicemail-switch").checked ? 1 : 0;
          if(this.querySelector('#dni-voicemail-switch').checked) {
            updated_dni_campaign.voicemail_rollover_time = this.querySelector("#dni_voicemail_rings").value;
            updated_dni_campaign.voicemail_audio_id = this.querySelector("#dni-voicemail-greeting-select").value == "null" ? null : this.querySelector("#dni-voicemail-greeting-select").value;
          }
        }
      } else {
        updated_dni_campaign.target = {};
        updated_dni_campaign.target.target_id = this.querySelector('.call_treatments_id').value;
      }

      updated_dni_campaign.dni_campaign_parameter_triggers.forEach(tag => {
        tag.delete = true;
      });

      this.querySelectorAll("dni-trigger-form").forEach((form) => {
        let parameter_trigger = form.getData();
        if(parameter_trigger.dni_campaign_parameter_trigger_id != null) {
          updated_dni_campaign.dni_campaign_parameter_triggers = updated_dni_campaign.dni_campaign_parameter_triggers.filter((param_trigger) => param_trigger.dni_campaign_parameter_trigger_id !== parameter_trigger.dni_campaign_parameter_trigger_id)
        }
        updated_dni_campaign.dni_campaign_parameter_triggers.push(parameter_trigger);
      });
      console.log("RRRRR " + JSON.stringify(updated_dni_campaign.dni_campaign_parameter_triggers))

      updated_dni_campaign.dni_campaign_parameter_targets.forEach(tag => {
        tag.delete = true;
      });
      this.querySelectorAll("url-redirect-form").forEach((form) => {
        let parameter_target = form.getData()
        if(parameter_target.dni_campaign_parameter_target_id != null) {
          updated_dni_campaign.dni_campaign_parameter_targets = updated_dni_campaign.dni_campaign_parameter_targets.filter((param_target) => param_target.dni_campaign_parameter_target_id !== parameter_target.dni_campaign_parameter_target_id)
        }
        updated_dni_campaign.dni_campaign_parameter_targets.push(parameter_target)
      })


      let res = await fetch(`/admin/domains/${this.domain_id}/dni_campaigns/${updated_dni_campaign.dni_campaign_id}`, {
        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                  'Content-type': 'application/json'},
        method: 'PUT',
        body: JSON.stringify(updated_dni_campaign)
      })
      button.disabled = false;
      if (!res.ok) // or check for response.status
          throw new Error(res.statusText);
      
      let response = await res.json();
      if(response.success) {
        Common.notify('Campaign updated', 'success');
        this.list_view.show();
        this.list_view.updateCampaignData(response.data)
        TreatmentsManager.reloadTreatments();
        this.remove();
      } else {
        Common.notify(`Unable to save Campaign. ${response.error ? response.error : ""}`, 'error');
      }
    }
  }

  async setStatus(status) {
    let res = await fetch(`/admin/domains/${this.domain_id}/dni_campaigns/${this._data.dni_campaign_id}/status`, {
      headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                'Content-type': 'application/json'},
      method: 'PUT',
      body: JSON.stringify({"status": status})
    })
    return res.ok;
  }

  cancelEdit(e) {
    e.preventDefault();
    this.remove();
    document.querySelector('.dni-campaigns-main').classList.remove('hidden');
  }

  validate() {
    let isValid = true;
    let errors = "";
    let number_to_replace = this.querySelector('#edit-dni-number').value.replace(/\D/g,'');
    let ring_to_number = this.querySelector('#new-dni-rtn').value.replace(/\D/g,'');
    this.querySelectorAll('.error').forEach(elem => {
      elem.classList.remove('error');
    })

    if(!this.querySelector('#edit-dni-name').value) {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong>Warning!</strong> Please provide a digital campaign name.
                  </div>`;
      this.querySelector('#edit-dni-name').classList.add('error');
      isValid = false;
    }

    if(!this.querySelector('#edit-dni-number').value) {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong>Warning!</strong> Please provide a valid Phone Number to Replace.
                  </div>`;
      this.querySelector('#edit-dni-number').classList.add('error');
      isValid = false;
    }

    if(number_to_replace != this._data.static_number) {
      if(this.all_numbers.some(num => num == number_to_replace)) {
        errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                      <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                      <strong>Warning!</strong> Number cannot already be in use in another campaign.
                    </div>`;
        this.querySelector('#edit-dni-number').classList.add('error');
        isValid = false;
      }
    }

    this._data.dni_campaign_pool.forEach(num => {
      if(num.did == number_to_replace) {
        errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong>Warning!</strong> Number in use in Campaign Pool.
                  </div>`;
      this.querySelector('#edit-dni-number').classList.add('error');
      isValid = false
      }
      if(num.did == ring_to_number) {
        errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong>Warning!</strong> Number in use in Campaign Pool.
                  </div>`;
      this.querySelector('#new-dni-rtn').classList.add('error');
      isValid = false
      }
    })

    if(this.querySelector('#ring-to-radio').checked && !this.querySelector('#new-dni-rtn').value) {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong>Warning!</strong> Please provide a valid Ring to Number.
                  </div>`;
      this.querySelector('#new-dni-rtn').classList.add('error');
      isValid = false
    } else if(this.querySelector('#call-treat-radio').checked && !this.querySelector('.call_treatments_id').value) {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong>Warning!</strong> Please select a call treatment.
                  </div>`;
      this.querySelector('.call_treatments_id').classList.add('error');
      isValid = false
    }

    if(!this.isTollFree() && this.querySelector('#texting-enabled-switch').checked && !this.querySelector('#texting-team-select').value) {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong>Warning!</strong> You must select a team if texting is enabled.
                  </div>`;
      this.querySelector('#texting-team-select').classList.add('error');
      isValid = false
    }

    if(this.querySelector('#call-rec-switch').checked && !this.querySelector('input[name="disclaimer-lang"]:checked')) {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong>Warning!</strong> Please choose a disclaimer language.
                  </div>`;
      isValid = false;
    }

    if(!this.querySelector('campaign-tags').validate()) {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong>Warning!</strong> Please select a tag name.
                  </div>`;
      isValid = false;
    }

    if(this._is_admin) {
      if(this.querySelector('#call-processing-map-switch').checked && !this.querySelector('#call-rec-switch').checked) {
        errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                      <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                      <strong>Warning!</strong> Call Recording must be turned on when turning on LeadScore.
                    </div>`;
        isValid = false;
      }
    }

    this.querySelector('.errors').innerHTML = errors;
    return isValid
  }

  poolSize(size) {
    this.querySelector('#dni-pool-size').value = size;
  }

  isTollFree() {
    const regex = /^(\+?1)?(8(00|33|44|55|66|77|88)[2-9]\d{6})$/;
    return regex.test(this._data.dni_campaign_pool[0].did);
  }
}

DNICampaignsEdit.BEGINNING_OF_CALL = 1;
DNICampaignsEdit.END_OF_CALL = 8;

customElements.define('dni-campaigns-edit', DNICampaignsEdit)

export class DNIEditMulti extends HTMLElement {
  constructor(domain_id, select_all, dni_ids, updated_callback) {
    super();
    this.domain_id = domain_id;
    this.select_all = select_all;
    this.dni_ids = dni_ids;
    this.updated_callback = updated_callback;
  }
  connectedCallback() {
    this.innerHTML = 
    `<style>
      #DNIeditMultiModal input[type="radio"] {
        display: none;
      }
    </style>
    <div class="modal fade bd-example-modal-sm" id="DNIeditMultiModal" data-cy="dni-edit-multi-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Edit Selected Campaigns</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-6 edit-multi-col">
                <div class="edit-multi-switch">
                  <label>Call Recording</label>
                  <div class="btn-group enable_call_recording" data-cy="multi_enable_call_recording" role="group" aria-label="...">
                    <input id=DNIcallRecMultT type=radio name=DNIcallRecMult value=true><label for=DNIcallRecMultT class="tern_toggle left">On</label><input id=DNIcallRecMultNC type=radio name=DNIcallRecMult value=no_change checked><label for=DNIcallRecMultNC class="tern_toggle mid">No Change</label><input id=DNIcallRecMultF type=radio name=DNIcallRecMult value=false><label for=DNIcallRecMultF class="tern_toggle right">Off</label>
                  </div>
                </div>
                <div class="edit-multi-switch">
                  <label>Active</label>
                  <div class="btn-group dni-status" data-cy="multi_status" role="group" aria-label="...">
                    <input id=statusMultT type=radio name=statusMult value=1><label for=statusMultT class="tern_toggle left">On</label><input id=statusMultNC type=radio name=statusMult value=no_change checked><label for=statusMultNC class="tern_toggle mid">No Change</label><input id=statusMultF type=radio name=statusMult value=0><label for=statusMultF class="tern_toggle right">Off</label>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 edit-multi-col">
                <div class="edit-multi-switch">
                  <label>Call Classification</label>
                  <div class="btn-group enable_call_classification" data-cy="multi_enable_call_classification" role="group" aria-label="...">
                    <input id=callClassMultT type=radio name=callClassMult value=true><label for=callClassMultT class="tern_toggle left">On</label><input id=callClassMultNC type=radio name=callClassMult value=no_change checked><label for=callClassMultNC class="tern_toggle mid">No Change</label><input id=callClassMultF type=radio name=callClassMult value=false><label for=callClassMultF class="tern_toggle right">Off</label>
                  </div>
                </div>
                <div class="edit-multi-switch">
                  <label>CallShield</label>
                  <div class="btn-group callshield" data-cy="multi_callshield" role="group" aria-label="...">
                    <input id=DNIcallshieldMultT type=radio name=DNIcallshieldMult value=true><label for=DNIcallshieldMultT class="tern_toggle left">On</label><input id=DNIcallshieldMultNC type=radio name=DNIcallshieldMult value=no_change checked><label for=DNIcallshieldMultNC class="tern_toggle mid">No Change</label><input id=DNIcallshieldMultF type=radio name=DNIcallshieldMult value=false><label for=DNIcallshieldMultF class="tern_toggle right">Off</label>
                  </div>
                </div>
              </div>
              <div class="col-md-12 edit-campaign-buttons">
                <button type="button" class="btn btn-primary save pull-right campaign-row-button" data-cy="save-multi-dni-edit">Save</button>
                <button type="button" class="btn btn-outline-secondary cancel pull-right campaign-row-button">Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>`;

    this.modal = this.querySelector('.modal');
    this.querySelector('.save').onclick = this.save.bind(this);
    this.querySelector('.cancel').onclick = this.cancel.bind(this);
    this.querySelector('.close').onclick = this.cancel.bind(this);
    this._defaults ={
      record: this.querySelector('#DNIcallRecMultNC'),
      status: this.querySelector('#statusMultNC'),
      call_classification: this.querySelector('#callClassMultNC'),
      callshield: this.querySelector('#DNIcallshieldMultNC'),
      ddn: this.querySelector('#ddnMultNC'),
    }
  }
  show(){
    $(this.modal).modal('show');
  }

  cancel(){
    $(this.modal).modal('hide');
    this.remove();
  }

  async save() {
    let button = this.querySelector('.save')
    button.disabled = true;

    let data = {};
    // Call recording data
    if(!this.querySelector("#DNIcallRecMultNC").checked) {
      data.call_recording = this.querySelector("input[name='DNIcallRecMult']").checked
    }
    // Status data
    if(!this.querySelector("#statusMultNC").checked) {
      data.status = this.querySelector("input[name='statusMult']").checked ? 1 : 2
    }
    // Call classification data
    if(!this.querySelector("#callClassMultNC").checked) {
      data.call_classification = this.querySelector("input[name='callClassMult']").checked
    }
    // CallShield data
    if(!this.querySelector("#DNIcallshieldMultNC").checked) {
      data.call_shield = this.querySelector("input[name='DNIcallshieldMult']").checked
    }
    this.select_all == true ? data.all_dni_campaigns = true : data.dni_campaign_ids = this.dni_ids;

    let res = await fetch(`/admin/domains/${this.domain_id}/dni_campaigns/update_batch`, {
      headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                'Content-type': 'application/json'},
      method: 'PUT',
      body: JSON.stringify(data)
    })

    button.disabled = false;
    if (!res.ok) // or check for response.status
        throw new Error(res.statusText);
    
    let response = await res.json();
    if(response.success) {
      Common.notify('Campaigns updated', 'success');
      this.updated_callback(true);
      $(this.modal).modal('hide');
      this.remove();
    } else {
      Common.notify('Unable to save Campaigns.', 'error');
    }
  }
}

customElements.define('dni-edit-multi', DNIEditMulti)

class DNIManagePools extends HTMLElement {
  constructor(pool_data, domain_id, campaign_id, changeCallback) {
    super();
    this.pool_data = pool_data;
    this.domain_id = domain_id;
    this.campaign_id = campaign_id;
    this.poolSizeUpdate = changeCallback;
  }
  connectedCallback() {
    this.innerHTML = 
      `<style>
        .manage-pools-tab {
          display: inline-block;
          padding: 10px;
          margin-bottom: 20px;
          color: gray;
        }
        .manage-pools-active {
          color: #337ab7;
          border-bottom: solid 2px #337ab7;
        }
        .manage-pools-tab:hover {
          cursor: pointer;
        }
        #manage-pool-size-btn {
          margin-top: -3px;
        }
        dni-manage-pools .modal-dialog {
          width: 1000px;
        }
        #dni-manage-pools-table_filter input, #dni-manage-pools-table_filter select {
          vertical-align: initial;
        }
        dni-manage-pools #npanxx-container {
          min-height: 112px;
        }
      </style>
      <button class="btn btn-secondary" id="manage-pool-size-btn">Manage</button>
      <div class="modal fade bd-example-modal-sm" id="DNIManagePoolsModal" data-cy="dni-manage-pools-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Manage Pools</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="manage-pools-tab manage-pools-active" id="dni-pool-tab">DNI Pool</div>
              <div class="manage-pools-tab" id="add-new-pools-tab">Add Pool</div>
              <div id="dni-pool-content">
                <table id="dni-manage-pools-table" class="table" style="width:100%; display:table;">
                  <thead>
                    <tr>
                      <th>Tracked Number</th>
                      <!--th>Status</th-->
                    </tr>
                  </thead>
                </table>
              </div>
              <div class="row hidden" id="add-new-pools-content">
                <div class="errors" data-cy="errors-1"></div>
                <div class="col-sm-12">
                  <label>Additional Pool Size</label>
                  <select class="form-control" id="manage-pool-size-select"></select>
                </div>
                <div class="col-sm-12">
                  <p>Find <b><u><span id="manage-pool-size-count">5</span> numbers</u></b> to assign to your pool</p>
                  <p><i>The selected numbers will be active and connected in 15 minutes.</i></p>
                  <div class="col-md-4 no-gutters form-group">
                    <label for="exampleFormControlInput1">Toll Free or Local</label><br/>
                    <input type="checkbox" id="campaign_wizard_toll_free" data-key="toll_free" class="wizard_toggle campaign_toll_free" data-on-text="Toll Free" data-off-color="default" data-off-text="Local">
                  </div>
                  <div class="col-md-8 form-group" id="local-tollfree-numbers">
                    <local-numbers class="hidden" numbers-required="5"></local-numbers>
                    <toll-free-numbers class="hidden"></toll-free-numbers>
                  </div>
                </div>
                <div class="col-md-12 edit-campaign-buttons">
                  <button type="button" class="btn btn-primary save pull-right campaign-row-button" data-cy="add-pools-btn">Add to Pool</button>
                  <button type="button" class="btn btn-outline-secondary cancel pull-right campaign-row-button">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>`;

    this.init();
    this.campaignNumber();
    this.querySelector("#manage-pool-size-btn").addEventListener("click", function(e){e.preventDefault(); $('#DNIManagePoolsModal').modal('show');});
    this.querySelectorAll('.manage-pools-tab').forEach(elem => elem.addEventListener('click', this.toggleView))
    
    this.numbers_required = 5;
    this.querySelector('#manage-pool-size-select').onchange = (e) => {
      this.numbers_required = this.querySelector('#manage-pool-size-count').innerHTML = e.target.value;
      this.querySelector("local-numbers").setAttribute("numbers-required", e.target.value)
    }

    this.querySelector('.cancel').onclick = this.cancel.bind(this);
    this.querySelector('.close').onclick = this.cancel.bind(this);
    this.querySelector('.save').onclick = this.save.bind(this);

    $(this.querySelector("#campaign_wizard_toll_free")).bootstrapSwitch('state', true);

    $(this.querySelector("#campaign_wizard_toll_free")).on('switchChange.bootstrapSwitch', function(event, state) {
      if(!state) {
        this.querySelector('#local-tollfree-numbers').classList.remove('col-md-8');
        this.querySelector('#local-tollfree-numbers').classList.add('col-md-12', 'no-gutters');
      } else {
        this.querySelector('#local-tollfree-numbers').classList.remove('col-md-12', 'no-gutters');
        this.querySelector('#local-tollfree-numbers').classList.add('col-md-8');
      }
    }.bind(this));
  }
  
  init() {
    this.table = $('#dni-manage-pools-table').DataTable({
      "data": this.pool_data,
      "columns": [
        { data : "did", "visible" : true, "searchable":true, "orderable":true,
          "render": function ( data, type, row ) {
            return type === 'display' ? Common.formatPhoneNumber(data) : data;
          }
        },
        // {
        //   "data": "status"
        // },
      ],
      "order": [[0, 'asc']]
    });
  }

  toggleView() {
    let dni_pool_tab = document.querySelector('#dni-pool-tab');
    let dni_pool = document.querySelector('#dni-pool-content');
    let new_pools_tab = document.querySelector('#add-new-pools-tab');
    let new_pools = document.querySelector('#add-new-pools-content');
    if(dni_pool_tab.classList.contains('manage-pools-active')) {
      dni_pool_tab.classList.remove('manage-pools-active');
      dni_pool.classList.add('hidden');
      new_pools_tab.classList.add('manage-pools-active');
      new_pools.classList.remove('hidden');
    } else if (new_pools_tab.classList.contains('manage-pools-active')) {
      dni_pool_tab.classList.add('manage-pools-active');
      dni_pool.classList.remove('hidden');
      new_pools_tab.classList.remove('manage-pools-active');
      new_pools.classList.add('hidden');
    }
  }

  campaignNumber() {
    let options = [];
    for(let i = 5; i <= 50; i+=5) {
      options.push(`<option value="${i}">${i}</option>`);
    }
    this.querySelector('#manage-pool-size-select').innerHTML = options.join('');
  }

  cancel(){
    $('#DNIManagePoolsModal').modal('hide');
  }

  async save() {
    if(!this.validate()) {
      return;
    }
    let data = {};
    if(this.querySelector(".campaign_toll_free").checked) {
      data.npanxx = [{"npanxx": this.querySelector("toll-free-numbers").value, "qtyRequired": this.numbers_required}]
    } else {
      data.npanxx = this.querySelector("local-numbers").value
    }

    let res = await fetch(`/admin/domains/${this.domain_id}/dni_campaigns/${this.campaign_id}/pool`, {
      headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                'Content-type': 'application/json'},
      method: 'POST',
      body: JSON.stringify(data)
    });
    let response = await res.json()
    if(response.success) {
      Common.notify('Campaign pool size increased.', 'success');
      this.table.clear().rows.add( response.data ).draw();
      this.querySelector(".manage-pools-active").click();
      this.poolSizeUpdate(response.data.length);
      this.cancel();
    } else {
      this.cancel();
      Common.notify('Unable to increase pool size.', 'error');
    }
  }

  validate() {
    this.querySelector('.errors').innerHTML = ``;
    let data = {};

    if(this.querySelector(".campaign_toll_free").checked) {
      data.npanxx = [{"npanxx": this.querySelector("toll-free-numbers").value, "qtyRequired": this.numbers_required}]
    } else {
      data.npanxx = this.querySelector("local-numbers").value
    }

    let total_to_provision = 0;
    data.npanxx.forEach((npanxx) => total_to_provision += Number(npanxx.qtyRequired))

    if(total_to_provision == this.numbers_required) {
      return true;
    } else {
      this.querySelector('.errors').innerHTML = `<div class="alert alert-danger alert-dismissible" role="alert">
          <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <strong>Warning!</strong> Please select more numbers for pool.
        </div>`;
      return false;
    }
  }
}

customElements.define('dni-manage-pools', DNIManagePools)